import { resolveIchiiPurchase } from './ichii-home-purchase.js';

let purchaseObserver;
function initIchiiHome() {
  const finalPurchase = document.querySelector('[data-ichii-final-purchase]');
  const stickyPurchase = document.querySelector('[data-ichii-sticky-purchase]');
  const heroPurchase = document.querySelector('.ichii-home--hero');
  const form = document.querySelector('[data-ichii-pair-form]');
  const catalogElement = document.querySelector('[data-ichii-pair-catalog]');

  if (form && catalogElement && !form.dataset.ichiiBound) {
    form.dataset.ichiiBound='true';
    const catalog = JSON.parse(catalogElement.textContent);
    const top = form.querySelector('[data-ichii-top-color]');
    const pants = form.querySelector('[data-ichii-pants-color]');
    const size = form.querySelector('[data-ichii-pair-size]');
    const button = form.querySelector('[data-ichii-pair-submit]');
    const fields = form.querySelector('fieldset');
    const price = form.querySelector('[data-ichii-pair-price]');
    const note = form.querySelector('[data-ichii-pair-note]');
    const status = form.querySelector('[data-ichii-pair-status]');
    const error = form.querySelector('[data-ichii-pair-error]');
    const cartCheck = form.querySelector('[data-ichii-cart-check]');
    const stickyPrice = document.querySelector('[data-ichii-sticky-price]');
    const money = new Intl.NumberFormat('ja-JP', { style: 'currency', currency: catalog.currency });
    let busy = false;
    const selection = () => ({ top: top.value, pants: pants.value, size: size.value });

    const update = () => {
      const result = resolveIchiiPurchase(catalog, selection());
      for (const [selector, color, garment] of [
        ['[data-ichii-top-image]', top.value, 'TOPS'],
        ['[data-ichii-pants-image]', pants.value, 'PANTS'],
      ]) {
        const img = finalPurchase.querySelector(selector);
        img.src = img.dataset[color.toLowerCase()];
        img.alt = `${color}の${garment}`;
      }
      price.textContent = result.price === null ? 'この組み合わせは販売準備中です。' : `${result.kind === 'set' ? 'SET' : 'TOPS + PANTS'}　${money.format(result.price / 100)}`;
      stickyPrice.textContent = result.price === null ? '上下の組み合わせ' : price.textContent;
      note.textContent = result.price === null ? '' : result.kind === 'set'
        ? `${top.value === pants.value ? '同色' : '別色'}SET・国内送料無料（SETのみのご注文）`
        : '単品2点の合計価格です。国内送料1,000円。';
      status.textContent = !size.value ? 'サイズを選んでください。' : result.available
        ? `TOPS：${top.value} / ${size.value}　PANTS：${pants.value} / ${size.value}`
        : 'この色・サイズの組み合わせは現在購入できません。';
      button.disabled = busy || !result.available;
    };

    for (const control of [top, pants, size]) control.addEventListener('change', update);
    form.addEventListener('submit', async event => {
      event.preventDefault();
      if (busy || !form.reportValidity()) return;
      const result = resolveIchiiPurchase(catalog, selection());
      if (!result.available) return;
      busy = true;
      fields.disabled = true;
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      error.hidden = true;
      cartCheck.hidden = true;
      try {
        const response = await fetch(`${form.action}.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: result.items }),
        });
        if (!response.ok) throw new Error('Cart rejected the selected items');
        window.location.assign(form.dataset.cartUrl);
      } catch {
        error.textContent = '追加を確認できませんでした。カートの内容を確認してから、もう一度お試しください。';
        error.hidden = false;
        cartCheck.hidden = false;
        busy = false;
        fields.disabled = false;
        button.removeAttribute('aria-busy');
        update();
      }
    });
    update();
  }

  if (!finalPurchase || !stickyPurchase || !('IntersectionObserver' in window)) return;

  if (purchaseObserver) purchaseObserver.disconnect();
  const visiblePurchases = new Set();
  const observer = new IntersectionObserver((entries) => {
    for (const entry of entries) {
      if (entry.isIntersecting) visiblePurchases.add(entry.target);
      else visiblePurchases.delete(entry.target);
    }
    stickyPurchase.hidden = visiblePurchases.size > 0;
  });
  purchaseObserver=observer;
  if (heroPurchase) observer.observe(heroPurchase);
  observer.observe(finalPurchase);
 }
initIchiiHome();
document.addEventListener('shopify:section:load', initIchiiHome);
document.addEventListener('click', event => {
 const link=event.target.closest('[data-ichii-pair-preset]');
 const form=document.querySelector('[data-ichii-pair-form]');
 if(!link || !form) return;
 if(form.querySelector('fieldset').disabled){event.preventDefault();return;}
 const top=form.querySelector('[data-ichii-top-color]');
 const pants=form.querySelector('[data-ichii-pants-color]');
 top.value=link.dataset.top; pants.value=link.dataset.pants;
 top.dispatchEvent(new Event('change',{bubbles:true}));
});
